const SEEN_KEY = 'jc-follow-email-prompt-seen';

/** TEC-514 #3: was "once per browser, ever", loosened to a 14-day cooldown so the offer
 * surfaces again for someone who ignored it a while back, without becoming a nag. */
const COOLDOWN_MS = 14 * 24 * 60 * 60 * 1000;

/**
 * Whether the follow -> email-updates offer (shown right after a first company follow or role
 * watch) should show now: never shown before, or last shown more than COOLDOWN_MS ago. A user
 * who ignores it can still enable alert emails any time from the Alerts page, and the caller
 * separately checks the subscription isn't already active before offering at all.
 *
 * The old "once ever" version stored a literal '1' on shown. Number('1') is 1, an epoch
 * timestamp from 1970, so under this cooldown logic every such flag reads as trivially expired
 * and the offer becomes eligible again immediately. That's the intended migration: loosening
 * the restriction should make previously-suppressed users eligible, not require a separate
 * one-time data migration.
 */
export function shouldShowFollowEmailPrompt(): boolean {
  try {
    const raw = localStorage.getItem(SEEN_KEY);
    if (!raw) return true;
    const lastShownAt = Number(raw);
    if (!Number.isFinite(lastShownAt)) return true;
    return Date.now() - lastShownAt >= COOLDOWN_MS;
  } catch {
    // Storage unavailable (SSR, privacy mode): err on not prompting.
    return false;
  }
}

export function markFollowEmailPromptSeen(): void {
  try {
    localStorage.setItem(SEEN_KEY, String(Date.now()));
  } catch {
    // Best effort only.
  }
}
